/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrencyCreateModel } from '../../models/currency-create-model';
import { CurrencyModel } from '../../models/currency-model';

export interface PostApiCurrencyV1Create$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The CurrencyCreateModel containing the details of the currency to create.
     */
    body?: CurrencyCreateModel
}

export function postApiCurrencyV1Create$Json(http: HttpClient, rootUrl: string, params?: PostApiCurrencyV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrencyModel>> {
  const rb = new RequestBuilder(rootUrl, postApiCurrencyV1Create$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrencyModel>;
    })
  );
}

postApiCurrencyV1Create$Json.PATH = '/private/v1/currencies/Create';
